export default function Directioneaza3LaSuta() {
    return (
        <div className="max-w-3xl mx-auto p-6 space-y-8">
            <h1 className="text-3xl font-bold">
                Direcționează 3% din impozitul pe venit
            </h1>

            <p className="text-gray-700">
                Susține activitatea Asociației Socrate fără niciun cost pentru tine.
                Redirecționezi 3% din impozitul pe venit deja plătit către educație.
            </p>

            <a
                href="/formular-230-asociatia-socrate.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block"
            >
                <button className="bg-emerald-600 text-white px-6 py-4 rounded-xl text-lg font-semibold hover:bg-emerald-700 transition">
                    Descarcă formular 230 precompletat
                </button>
            </a>

            <div className="bg-gray-50 rounded-xl p-5 space-y-2 text-sm">
                <h2 className="font-semibold">Cum funcționează?</h2>
                <ol className="list-decimal list-inside space-y-1 text-gray-700">
                    <li>Descarcă formularul 230 precompletat.</li>
                    <li>Completează datele tale personale.</li>
                    <li>Semnează formularul.</li>
                    <li>Depune-l online în Spațiul Privat Virtual sau la ANAF.</li>
                </ol>
            </div>
        </div>
    );
}
